import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";
import { UserModel } from "../../types/userDataModel";
import { useNavigate } from "react-router-dom";
import LocalStorageUtil from "../../utils/localStorage";

const getUserDataURL = urlConfig.GetUserDataURL;


export const getUsrData = async (
  email: string,
  navigate?: ReturnType<typeof useNavigate>
) => {
  try {
    const obj = {
      auth0Result: {
        idTokenPayload: {
          email: email,
        },
      },
    };
    const response = await postCall(getUserDataURL, obj);
    if (response == null || response.status != 200) {
        if(navigate != null)
        navigate("/forbidden")
        return;
      }
      const userData: UserModel = response.data;     
      LocalStorageUtil.setItem("userId", userData.userId.toString());
      LocalStorageUtil.setItem("groupId", userData.groupId.toString());
      LocalStorageUtil.setItem("folderRights", userData.folderRights.toString());
      LocalStorageUtil.setItem("businessUnitId", userData.businessUnitId.toString());
      LocalStorageUtil.setItem("contextName", userData.contextName.toString());
      LocalStorageUtil.setItem("initialContextName", userData.contextName.toString());
      LocalStorageUtil.setItem("accountId", userData.accountId.toString());
      LocalStorageUtil.setItem("authorizationData", JSON.stringify(userData, null, 2));
      LocalStorageUtil.setItem("firstName", userData.firstName.toString());
      LocalStorageUtil.setItem("lastName", userData.lastName.toString());
      LocalStorageUtil.setItem("metadatadefinitionId", userData.metadatadefinitionId?.toString());
      LocalStorageUtil.setItem("isSuperAdmin", userData.isSuperAdmin.toString());
      LocalStorageUtil.setItem("isAccountDAOEnabled", userData.isAccountDAOEnabled.toString());
      LocalStorageUtil.setItem("isAccountDSAEnabled", userData.isAccountDSAEnabled.toString());
      LocalStorageUtil.setItem("isAccountEdeliveryEnabled", userData.isAccountEdeliveryEnabled.toString());
      LocalStorageUtil.setItem("userName", userData.userName.toString());
      return userData;
  } catch (error) {
    console.error("Error in GetAntiForgeryToken data fetching ", error);
    //throw error;
  }
};